import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Add-task "label" metadata icon — a tag glyph on a rounded `#F9FAFB` tile,
 * used as the label (tag) picker trigger in the Board add-task creator. The
 * glyph inherits `color()` via `currentColor`; the tile fill is fixed.
 */
@Component({
  selector: 'lib-add-task-label-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="active() ? '#2970ff' : color()"
      [class]="iconClass()">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
        [attr.fill]="active() ? '#eff6ff' : '#F9FAFB'" />
      <path
        d="M12.0467 18.6525C11.1067 18.6525 10.1601 18.2925 9.44673 17.5791L6.42673 14.5591C5.69339 13.8258 5.30673 12.8125 5.35339 11.7791L5.51339 8.44581C5.58673 6.85247 6.84673 5.59247 8.44673 5.51247L11.7801 5.35247C12.8134 5.31247 13.8267 5.69247 14.5601 6.42581L17.5801 9.44581C19.0134 10.8791 19.0134 13.2191 17.5801 14.6525L14.6534 17.5791C13.9334 18.2925 12.9934 18.6525 12.0467 18.6525ZM7.13339 13.8458L10.1534 16.8658C10.6601 17.3725 11.3334 17.6525 12.0467 17.6525C12.7601 17.6525 13.4334 17.3725 13.9401 16.8658L16.8667 13.9391C17.3734 13.4325 17.6534 12.7591 17.6534 12.0458C17.6534 11.3325 17.3734 10.6591 16.8667 10.1525L13.8467 7.13247C13.3134 6.59914 12.5734 6.31247 11.8267 6.35247L8.49339 6.51247C7.40673 6.55914 6.56006 7.40581 6.50673 8.48581L6.34673 11.8191C6.31339 12.5725 6.60006 13.3125 7.13339 13.8458Z"
        fill="currentColor" />
      <path
        d="M10.3337 12.4993C9.14033 12.4993 8.16699 11.526 8.16699 10.3327C8.16699 9.13935 9.14033 8.16602 10.3337 8.16602C11.527 8.16602 12.5003 9.13935 12.5003 10.3327C12.5003 11.526 11.527 12.4993 10.3337 12.4993ZM10.3337 9.16602C9.69366 9.16602 9.16699 9.69268 9.16699 10.3327C9.16699 10.9727 9.69366 11.4993 10.3337 11.4993C10.9737 11.4993 11.5003 10.9727 11.5003 10.3327C11.5003 9.69268 10.9737 9.16602 10.3337 9.16602Z"
        fill="currentColor" />
    </svg>
  `,
})
export class AddTaskLabelIconComponent extends BaseIconComponent {
  override width = input<string>('24');
  override height = input<string>('24');
  override viewBox = input<string>('0 0 24 24');
  override color = input<string>('#6B7280');
  /** Active (picker open) state: primary-faint tile + primary glyph. */
  readonly active = input<boolean>(false);
}
